const _ = require('lodash');
const { Module, SurveyType, DataSourceType, LicenseInterval } = require('../prisma/types');
const {
  DEFAULT_MODEL,
  TAG_RESPONSES_SYSTEM_PROMPT,
  SUGGEST_TAGS_SYSTEM_PROMPT,
  SUMMARIZE_RESPONSES_SYSTEM_PROMPT,
} = require('./ai');

const ID = 'ID';
const TEXT = 'TEXT';
const NUMBER = 'NUMBER';
const BOOLEAN = 'BOOLEAN';
const ID_ARRAY = 'ID_ARRAY';
const SURVEY_GROUP_ID = 'SURVEY_GROUP_ID';
const ARRAY = 'ARRAY';
const PRICE = 'PRICE';
const OBJ = 'OBJ';

const SETTING_TYPES = {
  ID,
  TEXT,
  NUMBER,
  BOOLEAN,
  ID_ARRAY,
  SURVEY_GROUP_ID,
  ARRAY,
  PRICE,
  OBJ,
};

const SETTING_TYPES_COLUMN_WIDTH = {
  ID: 250,
  TEXT: 400,
  NUMBER: 100,
  BOOLEAN: 100,
  ID_ARRAY: 250,
  SURVEY_GROUP_ID: 200,
  ARRAY: 200,
  PRICE: 400,
};

const ALL_SETTINGS = {
  reportContentAISummary: {
    type: BOOLEAN,
    defaultValue: false,
  },
  disableAI: {
    type: BOOLEAN,
    defaultValue: false,
  },
  surveyLimit: {
    type: NUMBER,
  },
  generalSurveyLimit: {
    type: NUMBER,
  },
  feedbackLimit: {
    type: NUMBER,
  },
  targetedSurveyLimit: {
    type: NUMBER,
  },
  cxSurveyLimit: {
    type: NUMBER,
  },
  customTheme: {
    type: BOOLEAN,
  },
  userSegmentLimit: {
    type: NUMBER,
  },
  sharedSegmentLimit: {
    type: NUMBER,
  },
  matomoSegmentLimit: {
    type: NUMBER,
  },
  funnelLimit: {
    type: NUMBER,
  },
  tagComments: {
    type: BOOLEAN,
  },
  aiSummaries: {
    type: BOOLEAN,
  },
  userLimit: {
    type: NUMBER,
  },
  advancedUserLimit: {
    type: NUMBER,
  },
  responseLimit: {
    type: NUMBER,
  },
  yearlyResponseLimit: {
    type: NUMBER,
  },
  accessibilityEnabled: {
    type: BOOLEAN,
  },
  accessibilityPageLimit: {
    type: NUMBER,
  },
  heatmapLimit: {
    type: NUMBER,
  },
  heatmapSampleLimit: {
    type: NUMBER,
  },
  sessionRecordingLimit: {
    type: NUMBER,
  },
  sessionRecordingSampleLimit: {
    type: NUMBER,
  },
  surveyVersionLimit: {
    type: NUMBER,
  },
  surveyLanguageLimit: {
    type: NUMBER,
  },
  matomoMonthlyVisitLimit: {
    type: NUMBER,
  },
  dedicatedAnalyst: {
    type: BOOLEAN,
  },
  unlimitedHeatmaps: {
    type: BOOLEAN,
  },
  reportLimit: {
    type: NUMBER,
  },
  customCookiePrefix: {
    type: BOOLEAN,
  },
  disableCookies: {
    type: BOOLEAN,
  },
  yearlyPrices: {
    type: ARRAY,
    private: true,
    settings: ['matomoMonthlyVisitLimit', 'analytics', 'unlimitedHeatmaps', 'dedicatedAnalyst'],
  },
  monthlyPrices: {
    type: ARRAY,
    private: true,
    settings: ['matomoMonthlyVisitLimit', 'analytics', 'unlimitedHeatmaps', 'dedicatedAnalyst'],
  },
  yearlyPrice: {
    type: PRICE,
  },
  monthlyPrice: {
    type: PRICE,
  },
  pipedriveTrialPipelineId: {
    type: NUMBER,
  },
  pipedriveTrialStageId: {
    type: NUMBER,
  },
  pipedrivePayingPipelineId: {
    type: NUMBER,
  },
  pipedrivePayingStageId: {
    type: NUMBER,
  },
  pipedriveInitialOwnerId: {
    type: NUMBER,
  },
  pipedriveFieldLicenseStartDateId: {
  },
  pipedriveFieldLicenseEndDateId: {
  },
  pipedriveFieldLicenseRenewalDateId: {
  },
  pipedriveFieldLicenseIntervalId: {
  },
  pipedriveFieldLicenseIntervalTrialId: {
    type: NUMBER,
  },
  pipedriveFieldLicenseIntervalMonthlyId: {
    type: NUMBER,
  },
  pipedriveFieldLicenseIntervalYearlyId: {
    type: NUMBER,
  },
  pipedriveFieldLicenseFreeTrialId: {
  },
  pipedriveFieldLicenseFreeTrialYesId: {
    type: NUMBER,
  },
  pipedriveFieldOrganizationPDCId: {
  },
  pipedriveFieldOrganizationPDCCustomerId: {
    type: NUMBER,
  },
  pipedriveFieldOrganizationPDCExtellioId: {
    type: NUMBER,
  },
  pipedriveFieldSubprocessorEmailListId: {
    defaultValue: '8888924554ffeacffdd8c8a17ce5f7d319b4d03d',
  },
  pipedriveFieldSubprocessorEmailListYesId: {
    type: NUMBER,
    defaultValue: 181,
  },
  pipedriveProductId: {
    private: true,
    type: NUMBER,
  },
  actionLimit: {
    type: NUMBER,
  },
  dailyHeatmapSampleLimit: {
    type: NUMBER,
  },
  dailySessionRecordingLimit: {
    type: NUMBER,
  },
  visitLimit: {
    type: NUMBER,
  },
  crashAnalytics: {
    type: BOOLEAN,
  },
  formAnalytics: {
    type: BOOLEAN,
  },
  mediaAnalytics: {
    type: BOOLEAN,
  },
  eCommerceAnalytics: {
    type: BOOLEAN,
  },
  multiAttribution: {
    type: BOOLEAN,
  },
  dataRetentionMonths: {
    type: NUMBER,
  },
  seoWebVitals: {
    type: BOOLEAN,
  },
  goalLimit: {
    type: NUMBER,
  },
  heatmapsDataRetentionDays: {
    type: NUMBER,
  },
  monthlyBrokenlinksCheckLimit: {
    type: NUMBER,
  },
  brokenLinksWeeklyCheck: {
    type: BOOLEAN,
  },
  brokenLinksMonthlyCheck: {
    type: BOOLEAN,
  },
  advancedCampaignParameters: {
    type: BOOLEAN,
  },
  expertCampaignParameters: {
    type: BOOLEAN,
  },
  monthlySinglePrice: {
    type: PRICE,
  },
  monthlyMultiplePrice: {
    type: PRICE,
  },
  templateCustomerId: {
    type: ID,
  },
  feedbackTemplatesWebsiteId: {
    type: ID,
  },
  targetedSurveyTemplatesWebsiteId: {
    type: ID,
  },
  globalBenchmarkCategoryId: {
    type: ID,
  },
  customerOwnerRoleId: {
    type: ID,
  },
  customerAdvancedUserRoleId: {
    type: ID,
  },
  dataSourceOwnerRoleId: {
    type: ID,
  },
  dataSourceAdvancedUserRoleId: {
    type: ID,
  },
  nextOrderNumber: {
    type: NUMBER,
  },
  domain: {},
  blockedDomains: {
    type: ARRAY,
    settings: ['domain'],
  },
  blockedEmailDomains: {
    type: ARRAY,
    settings: ['domain'],
  },
  demoUserEmail: {},
  demoUserPassword: {},
  demoData: {
    type: OBJ,
  },
  piiScanSettings: {
    type: OBJ,
  },
  demoTargetDataSourceId: {
    type: ID,
  },
  demoTargetSurveyIds: {
    type: ID_ARRAY,
  },
  demoShowDataSource: {
    type: BOOLEAN,
  },
  heatmapsDaysBeforeEmptyAlert: {
    type: NUMBER,
  },
  heatmapsMinSamplesBeforeDataAlert: {
    type: NUMBER,
  },
  sessionRecordingsDaysBeforeEmptyAlert: {
    type: NUMBER,
  },
  sessionRecordingsMinSamplesBeforeDataAlert: {
    type: NUMBER,
  },
  selectedCustomer: {
    type: ID,
  },
  generalSurveyTemplate: {
    type: SURVEY_GROUP_ID,
    globalSetting: 'templateCustomerId',
  },
  feedbackTemplate: {
    type: SURVEY_GROUP_ID,
    globalSetting: 'templateCustomerId',
  },
  targetedSurveyTemplate: {
    type: SURVEY_GROUP_ID,
    globalSetting: 'templateCustomerId',
  },
  analyticsDashboardPageId: {
    type: ID,
  },
  freeTrialVisitLimit: {
    type: NUMBER,
  },
  freeTrialActionLimit: {
    type: NUMBER,
  },
  freeTrialHeatmapSampleLimit: {
    type: NUMBER,
  },
  bundleDiscounts: {
    type: ARRAY,
    settings: ['licenseLevel', 'nrOfProducts', 'bundleDiscount'],
  },
  licenseLevel: {
    type: NUMBER,
  },
  nrOfProducts: {
    type: NUMBER,
  },
  bundleDiscount: {
    type: NUMBER,
  },
  incompleteSignupReminderDays: {
    type: ID_ARRAY,
  },
  incompleteSignupReminderDaysSent: {
    type: ID_ARRAY,
    private: true,
  },
  activeAccountInvitationReminderDays: {
    type: ID_ARRAY,
  },
  activeAccountInvitationReminderDaysSent: {
    type: ID_ARRAY,
    private: true,
  },
  scriptInstallationReminderDays: {
    type: ID_ARRAY,
  },
  scriptInstallationReminderDaysSent: {
    type: ID_ARRAY,
    private: true,
  },
  emailTemplateUserInvitationEn: {
    type: NUMBER,
    defaultValue: 62,
  },
  emailTemplateReportEn: {
    type: NUMBER,
    defaultValue: 27,
  },
  emailTemplateReportSv: {
    type: NUMBER,
    defaultValue: 28,
  },
  emailTemplateReportNb: {
    type: NUMBER,
    defaultValue: 29,
  },
  emailTemplateContactQuestionEn: {
    type: NUMBER,
    defaultValue: 31,
  },
  emailTemplateClientPanelEn: {
    type: NUMBER,
    defaultValue: 30,
  },
  emailTemplateClientPanelSv: {
    type: NUMBER,
    defaultValue: 33,
  },
  emailTemplateClientPanelNb: {
    type: NUMBER,
    defaultValue: 34,
  },
  emailTemplateClientPanelDe: {
    type: NUMBER,
    defaultValue: 35,
  },
  emailTemplateClientPanelFi: {
    type: NUMBER,
    defaultValue: 36,
  },
  emailTemplateClientPanelDa: {
    type: NUMBER,
    defaultValue: 37,
  },
  emailTemplateClientPanelEs: {
    type: NUMBER,
    defaultValue: 38,
  },
  emailTemplateClientPanelIt: {
    type: NUMBER,
    defaultValue: 39,
  },
  emailTemplateClientPanelFr: {
    type: NUMBER,
    defaultValue: 40,
  },
  emailTemplatePasswordResetEn: {
    type: NUMBER,
    defaultValue: 41,
  },
  emailTemplateMfaCodeEn: {
    type: NUMBER,
    defaultValue: 75,
  },
  emailTemplateSignUpEn: {
    type: NUMBER,
    defaultValue: 61,
  },
  emailTemplateSignUpReminderEn: {
    type: NUMBER,
    defaultValue: 61,
  },
  emailTemplateUserInvitationReminderEn: {
    type: NUMBER,
    defaultValue: 62,
  },
  emailTemplateScriptInstallationReminderEn: {
    type: NUMBER,
    defaultValue: 45,
  },
  emailTemplateScriptInstructionsEn: {
    type: NUMBER,
    defaultValue: 45,
  },
  emailTemplateOrderConfirmationEn: {
    type: NUMBER,
    defaultValue: 52,
  },
  emailTemplateOrderRenewalEn: {
    type: NUMBER,
    defaultValue: 54,
  },
  emailTemplateBrokenLinksReportEn: {
    type: NUMBER,
    defaultValue: 55,
  },
  emailTemplateDemoSignupEn: {
    type: NUMBER,
    defaultValue: 76,
  },
  emailTemplateSubprocessorSignupEn: {
    type: NUMBER,
    defaultValue: 77,
  },
  aiAutoTaggingSystemPrompt: {
    type: TEXT,
    defaultValue: TAG_RESPONSES_SYSTEM_PROMPT,
  },
  aiSummarySystemPrompt: {
    type: TEXT,
    defaultValue: SUMMARIZE_RESPONSES_SYSTEM_PROMPT,
  },
  aiCategorySystemPrompt: {
    type: TEXT,
    defaultValue: SUGGEST_TAGS_SYSTEM_PROMPT,
  },
  aiDefaultModel: {
    type: TEXT,
    defaultValue: DEFAULT_MODEL,
  },
  aiFallbackModels: {
    type: TEXT,
  },
  aiOpenaiApiKey: {
    type: TEXT,
    private: true,
    secret: true,
  },
  aiGoogleApiKey: {
    type: TEXT,
    private: true,
    secret: true,
  },
  aiAzureFoundryApiKey: {
    type: TEXT,
    private: true,
    secret: true,
  },
  aiAzureFoundryResourceName: {
    type: TEXT,
  },
  aiAzureFoundryApiVersion: {
    type: TEXT,
  },
};

const LICENSE_SETTINGS = _.pick(ALL_SETTINGS, [
  'surveyLimit',
  'generalSurveyLimit',
  'feedbackLimit',
  'targetedSurveyLimit',
  'cxSurveyLimit',
  'customTheme',
  'userSegmentLimit',
  'sharedSegmentLimit',
  'matomoSegmentLimit',
  'funnelLimit',
  'tagComments',
  'aiSummaries',
  'userLimit',
  'advancedUserLimit',
  'responseLimit',
  'yearlyResponseLimit',
  'accessibilityEnabled',
  'accessibilityPageLimit',
  'heatmapLimit',
  'heatmapSampleLimit',
  'sessionRecordingLimit',
  'sessionRecordingSampleLimit',
  'surveyVersionLimit',
  'surveyLanguageLimit',
  'matomoMonthlyVisitLimit',
  'dedicatedAnalyst',
  'unlimitedHeatmaps',
  'reportLimit',
  'customCookiePrefix',
  'disableCookies',
  'yearlyPrices',
  'monthlyPrices',
  'yearlyPrice',
  'monthlyPrice',
  'pipedriveProductId',
  'actionLimit',
  'dailyHeatmapSampleLimit',
  'dailySessionRecordingLimit',
  'visitLimit',
  'crashAnalytics',
  'formAnalytics',
  'mediaAnalytics',
  'eCommerceAnalytics',
  'multiAttribution',
  'dataRetentionMonths',
  'seoWebVitals',
  'goalLimit',
  'heatmapsDataRetentionDays',
  'monthlyBrokenlinksCheckLimit',
  'brokenLinksWeeklyCheck',
  'brokenLinksMonthlyCheck',
  'advancedCampaignParameters',
  'expertCampaignParameters',
]);

const ANALYTICS_SETTINGS = {
  ..._.pick(LICENSE_SETTINGS, [
    'userLimit',
    'advancedUserLimit',
    'reportLimit',
    'disableCookies',
    'customCookiePrefix',
    'dataRetentionMonths',
    'pipedriveProductId',
    'crashAnalytics',
    'formAnalytics',
    'mediaAnalytics',
    'eCommerceAnalytics',
    'multiAttribution',
    'seoWebVitals',
    'goalLimit',
    'monthlyBrokenlinksCheckLimit',
    'brokenLinksWeeklyCheck',
    'brokenLinksMonthlyCheck',
    'advancedCampaignParameters',
    'expertCampaignParameters',
  ]),
  prices: {
    type: ARRAY,
    private: true,
    settings: ['visitLimit', 'actionLimit', 'monthlyPrice'],
  },
};

const HEATMAPS_SETTINGS = {
  ..._.pick(LICENSE_SETTINGS, [
    'userLimit',
    'advancedUserLimit',
    'reportLimit',
    'heatmapsDataRetentionDays',
    'pipedriveProductId',
    'heatmapLimit',
  ]),
  prices: {
    type: ARRAY,
    private: true,
    settings: ['visitLimit', 'dailyHeatmapSampleLimit', 'dailySessionRecordingLimit', 'monthlyPrice'],
  },
};

const UX_SURVEYS_SETTINGS = {
  ..._.pick(LICENSE_SETTINGS, [
    'userLimit',
    'advancedUserLimit',
    'reportLimit',
    'pipedriveProductId',
    'surveyLimit',
    'generalSurveyLimit',
    'feedbackLimit',
    'targetedSurveyLimit',
    'customTheme',
    'userSegmentLimit',
    'surveyVersionLimit',
    'surveyLanguageLimit',
    'tagComments',
    'aiSummaries',
  ]),
  prices: {
    type: ARRAY,
    private: true,
    settings: ['responseLimit', 'visitLimit', 'monthlyPrice'],
  },
};

const CX_SURVEYS_SETTINGS = {
  ..._.pick(LICENSE_SETTINGS, [
    'userLimit',
    'advancedUserLimit',
    'reportLimit',
    'pipedriveProductId',
    'cxSurveyLimit',
    'customTheme',
    'userSegmentLimit',
    'surveyVersionLimit',
    'surveyLanguageLimit',
    'tagComments',
    'aiSummaries',
  ]),
  prices: {
    type: ARRAY,
    private: true,
    settings: ['yearlyResponseLimit', 'yearlyPrice'],
  },
};

const ACCESSIBILITY_SETTINGS = {
  ..._.pick(LICENSE_SETTINGS, [
    'pipedriveProductId',
    'brokenLinksWeeklyCheck',
    'brokenLinksMonthlyCheck',
  ]),
  prices: {
    type: ARRAY,
    private: true,
    settings: ['accessibilityPageLimit', 'monthlyPrice'],
  },
};

const ADDON_SETTINGS = _.pick(ALL_SETTINGS, [
  'monthlySinglePrice',
  'monthlyMultiplePrice',
]);

const MODULE_LICENSE_SETTINGS = {
  [Module.Analytics]: ANALYTICS_SETTINGS,
  [Module.Heatmaps]: HEATMAPS_SETTINGS,
  [Module.UxSurveys]: UX_SURVEYS_SETTINGS,
  [Module.CxSurveys]: CX_SURVEYS_SETTINGS,
  [Module.Accessibility]: ACCESSIBILITY_SETTINGS,
  [Module.Addon]: ADDON_SETTINGS,
};

const MODULE_LIMIT_SETTING = {
  [Module.Analytics]: 'actionLimit',
  [Module.Heatmaps]: 'dailyHeatmapSampleLimit',
  [Module.UxSurveys]: 'visitLimit',
  [Module.CxSurveys]: 'yearlyResponseLimit',
  [Module.Accessibility]: 'accessibilityPageLimit',
};

const MODULE_FREE_LIMIT_SETTING = {
  [Module.Analytics]: 'actionLimit',
  [Module.Heatmaps]: 'dailyHeatmapSampleLimit',
  [Module.UxSurveys]: 'responseLimit',
  [Module.CxSurveys]: 'yearlyResponseLimit',
  [Module.Accessibility]: 'accessibilityPageLimit',
};

const PERIOD_INTERVAL = {
  [DataSourceType.Website]: LicenseInterval.Monthly,
  [DataSourceType.Cx]: LicenseInterval.Yearly,
};

const MODULE_LABEL = {
  [Module.Analytics]: 'Analytics',
  [Module.Heatmaps]: 'Heatmaps & recordings',
  [Module.UxSurveys]: 'UX-surveys',
  [Module.CxSurveys]: 'CX-surveys',
  [Module.Accessibility]: 'Accessibility',
  [Module.Addon]: 'Addon',
};

const MODULE_LIMIT_SETTING_LABEL = {
  actionLimit: 'Actions/month',
  visitLimit: 'Visits/month',
  responseLimit: 'Responses/month',
  yearlyResponseLimit: 'Responses/year',
  accessibilityPageLimit: 'Pages',
  dailyHeatmapSampleLimit: 'Heatmap samples/day',
  dailySessionRecordingLimit: 'Recorded sessions/day',
};

const SURVEY_TYPE_LIMITS = {
  [SurveyType.General]: 'generalSurveyLimit',
  [SurveyType.Feedback]: 'feedbackLimit',
  [SurveyType.Targeted]: 'targetedSurveyLimit',
  [SurveyType.Cx]: 'cxSurveyLimit',
};

const SURVEY_LIMIT_TYPES = {
  generalSurveyLimit: SurveyType.General,
  feedbackLimit: SurveyType.Feedback,
  targetedSurveyLimit: SurveyType.Targeted,
  cxSurveyLimit: SurveyType.Cx,
};

const GLOBAL_SETTINGS = _.pick(ALL_SETTINGS, [
  'templateCustomerId',
  'feedbackTemplatesWebsiteId',
  'targetedSurveyTemplatesWebsiteId',
  'globalBenchmarkCategoryId',
  'customerOwnerRoleId',
  'customerAdvancedUserRoleId',
  'dataSourceOwnerRoleId',
  'dataSourceAdvancedUserRoleId',
  'nextOrderNumber',
  'blockedDomains',
  'blockedEmailDomains',
  'demoUserEmail',
  'demoUserPassword',
  'demoData',
  'demoTargetDataSourceId',
  'demoTargetSurveyIds',
  'demoShowDataSource',
  'analyticsDashboardPageId',
  'freeTrialVisitLimit',
  'freeTrialActionLimit',
  'freeTrialHeatmapSampleLimit',
  'bundleDiscounts',
  'incompleteSignupReminderDays',
  'activeAccountInvitationReminderDays',
  'scriptInstallationReminderDays',
  'heatmapsDaysBeforeEmptyAlert',
  'heatmapsMinSamplesBeforeDataAlert',
  'sessionRecordingsDaysBeforeEmptyAlert',
  'sessionRecordingsMinSamplesBeforeDataAlert',
]);

const PIPEDRIVE_SETTINGS = _.pick(ALL_SETTINGS, [
  'pipedriveTrialPipelineId',
  'pipedriveTrialStageId',
  'pipedrivePayingPipelineId',
  'pipedrivePayingStageId',
  'pipedriveInitialOwnerId',
  'pipedriveFieldLicenseStartDateId',
  'pipedriveFieldLicenseEndDateId',
  'pipedriveFieldLicenseRenewalDateId',
  'pipedriveFieldLicenseIntervalId',
  'pipedriveFieldLicenseIntervalTrialId',
  'pipedriveFieldLicenseIntervalMonthlyId',
  'pipedriveFieldLicenseIntervalYearlyId',
  'pipedriveFieldLicenseFreeTrialId',
  'pipedriveFieldLicenseFreeTrialYesId',
  'pipedriveFieldOrganizationPDCId',
  'pipedriveFieldOrganizationPDCCustomerId',
  'pipedriveFieldOrganizationPDCExtellioId',
  'pipedriveFieldSubprocessorEmailListId',
  'pipedriveFieldSubprocessorEmailListYesId',
]);

const EMAIL_TEMPLATE_SETTINGS = _.pick(ALL_SETTINGS, [
  'emailTemplateUserInvitationEn',
  'emailTemplateReportEn',
  'emailTemplateReportSv',
  'emailTemplateReportNb',
  'emailTemplateContactQuestionEn',
  'emailTemplateClientPanelEn',
  'emailTemplateClientPanelSv',
  'emailTemplateClientPanelNb',
  'emailTemplateClientPanelDe',
  'emailTemplateClientPanelFi',
  'emailTemplateClientPanelDa',
  'emailTemplateClientPanelEs',
  'emailTemplateClientPanelIt',
  'emailTemplateClientPanelFr',
  'emailTemplatePasswordResetEn',
  'emailTemplateMfaCodeEn',
  'emailTemplateSignUpEn',
  'emailTemplateSignUpReminderEn',
  'emailTemplateUserInvitationReminderEn',
  'emailTemplateScriptInstallationReminderEn',
  'emailTemplateScriptInstructionsEn',
  'emailTemplateOrderConfirmationEn',
  'emailTemplateOrderRenewalEn',
  'emailTemplateBrokenLinksReportEn',
  'emailTemplateDemoSignupEn',
  'emailTemplateSubprocessorSignupEn',
]);

const PII_SCAN_SETTINGS = _.pick(ALL_SETTINGS, [
  'piiScanSettings',
]);

const AI_PROMPT_SETTINGS = _.pick(ALL_SETTINGS, [
  'aiAutoTaggingSystemPrompt',
  'aiSummarySystemPrompt',
  'aiAutoTaggingPromptTemplate',
  'aiCategorySystemPrompt',
  'aiCategoryPromptTemplate',
  'aiDefaultProvider',
  'aiDefaultModel',
  'aiFallbackModels',
  'aiOpenaiApiKey',
  'aiGoogleApiKey',
  'aiAzureFoundryApiKey',
  'aiAzureFoundryResourceName',
  'aiAzureFoundryApiVersion',
]);

const USER_GLOBAL_SETTINGS = _.pick(ALL_SETTINGS, [
  'selectedCustomer',
]);

const SURVEY_TEMPLATE_SETTINGS = _.pick(ALL_SETTINGS, [
  'generalSurveyTemplate',
  'feedbackTemplate',
  'targetedSurveyTemplate',
]);

const SURVEY_TYPE_TEMPLATES_SETTINGS = {
  [SurveyType.General]: 'generalSurveyTemplate',
  [SurveyType.Feedback]: 'feedbackTemplate',
  [SurveyType.Targeted]: 'targetedSurveyTemplate',
};

module.exports = {
  SETTING_TYPES,
  SETTING_TYPES_COLUMN_WIDTH,
  LICENSE_SETTINGS,
  PERIOD_INTERVAL,
  MODULE_LICENSE_SETTINGS,
  MODULE_LIMIT_SETTING,
  MODULE_FREE_LIMIT_SETTING,
  MODULE_LABEL,
  MODULE_LIMIT_SETTING_LABEL,
  SURVEY_TYPE_LIMITS,
  SURVEY_LIMIT_TYPES,
  GLOBAL_SETTINGS,
  PIPEDRIVE_SETTINGS,
  EMAIL_TEMPLATE_SETTINGS,
  PII_SCAN_SETTINGS,
  AI_PROMPT_SETTINGS,
  USER_GLOBAL_SETTINGS,
  SURVEY_TEMPLATE_SETTINGS,
  SURVEY_TYPE_TEMPLATES_SETTINGS,
  ALL_SETTINGS,
};
